import React from 'react';
import { Grid } from '@material-ui/core';

import ActiveStudentsChart from '../charts/ActiveStudentsChart';
import OverallCurriculumProgressChart from '../charts/OverallCurriculumProgressChart';
import ActivitiesCompletedChart from '../charts/ActivitiesCompletedChart';
import AverageWeeklyTimeSpentChart from '../charts/AverageWeeklyTimeSpentChart';

const OrganizationOverrallCards: React.FC = () => {
  return (
    <section>
      <Grid container wrap="wrap" spacing={2} justify="center">
        <Grid item xs={6} lg={3}>
          <OverallCurriculumProgressChart />
        </Grid>
        <Grid item xs={6} lg={3}>
          <ActiveStudentsChart />
        </Grid>
        <Grid item xs={6} lg={3}>
          <ActivitiesCompletedChart />
        </Grid>
        <Grid item xs={6} lg={3}>
          <AverageWeeklyTimeSpentChart />
        </Grid>
      </Grid>
    </section>
  );
};

export default OrganizationOverrallCards;
